import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_TRANSACTION_BY_ORGANIZATION_ID } from "../../../../graphql/queries/transaction";
import { Transaction, data } from "./bigchartdata";
import {
  BigChartContainer,
  BigChartWrapper,
  ThirdChart,
  ChartBigData,
  ChartBigPrice,
  ChartBigAmount,
  ChartBigPercent,
  ChartAmountContent,
  ChartInnerDiv,
  ChartFlow,
  ChartFlowContainer,
  ChartFlowContent,
  ChartFlowWrapper,
  ChartFlowDiv,
  Circle,
  Circle01,
  StyledAreaChart,
} from "./bigChart.styles";
import { ChartContent, ChartSpan, ChartData } from "../HomeChart/chart.styles";
import { colors } from "../../../../theme/color";
import { LuCalendarDays } from "react-icons/lu";
import {
  FlyoutMenu,
  CalendarText,
  YearFilter,
  DropDownIcon,
  DropDownMenuList,
  DropDownMenu,
} from "../../../../pages/Dashboard/Dashboard.styles";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { GET_PAYMENT_LINK_BY_ORGANIZATION_ID } from "../../../../graphql/queries/paymentlink";
import environment from "../../../../env";

const Index = () => {
  const [isDropDown, setIsDropDown] = useState(false);
  const [selectedYear, setSelectedYear] = useState("2023");
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [dataTrans, setDataTrans] = useState(data);
  const years = ["2023", "2024", "2025", "2026"];

  const {
    loading,
    error,
    data: queryData,
  } = useQuery(GET_TRANSACTION_BY_ORGANIZATION_ID, {
    variables: {
      payload: {
        limit: 10,
        page: 1,
      },
    },
  });

  const transactions = queryData?.getAllTransactionsByOrganizationId?.data;
  console.log("TRANSACTION", transactions);

  const {
    loading: paymentsLoading,
    error: paymentsError,
    data: paymentsDataQuery,
  } = useQuery(GET_PAYMENT_LINK_BY_ORGANIZATION_ID, {
    variables: {
      ...environment.paymentLinkService,
      payload: {
        limit: 10,
        page: 1,
      },
    },
  });

  const paymentData =
    paymentsDataQuery?.getAllpaymentLinkByOrganizationId?.data || [];

  console.log("PAYMENT LINKS TRANSACTIONS", paymentData);

  useEffect(() => {
    console.log("This is working", transactions);
    if (queryData && queryData.getAllTransactionsByOrganizationId) {
      const transactions: Transaction[] =
        queryData.getAllTransactionsByOrganizationId.data;
      const monthlyData = data.map((month, index) => {
        const monthlyTransactions = transactions.filter((transaction) => {
          const transactionDate = new Date(parseInt(transaction.updatedAt));
          return (
            transactionDate.getMonth() === index &&
            transactionDate.getFullYear().toString() === selectedYear
          );
        });

        const totalUv = monthlyTransactions.reduce(
          (sum, trans) => sum + trans.quantity,
          0
        );
        const totalPv = monthlyTransactions.reduce(
          (sum, trans) => sum + trans.price,
          0
        );
        const totalAmt = monthlyTransactions.reduce(
          (sum, trans) => sum + trans.amount,
          0
        );

        const newData = { ...month, uv: totalUv, pv: totalPv, amt: totalAmt };
        console.log("NEW DATA", newData);
        return newData;
      });
      setDataTrans(monthlyData);
    }
  }, [queryData, selectedYear]);

  const handleDropDownMenu = () => {
    setIsDropDown(!isDropDown);
  };

  const handleSelectedIndex = (index: number) => {
    setSelectedIndex(index);
    setSelectedYear(years[index]);
    setIsDropDown(!isDropDown);
  };

  return (
    <BigChartContainer>
      <BigChartWrapper>
        <ThirdChart>
          <ChartContent>
            <div>
              <ChartSpan>Payment Analytics</ChartSpan>
            </div>
            <div>
              <FlyoutMenu>
                <YearFilter onClick={handleDropDownMenu}>
                  <LuCalendarDays
                    color={colors.ButtonBackgroundColors.primaryDefaultButton}
                    size={"20px"}
                  />
                  <CalendarText>Year {selectedYear} </CalendarText>
                  <DropDownIcon
                    src="/assets/icons/Drop_Down.png"
                    onClick={handleDropDownMenu}
                  />
                </YearFilter>

                <DropDownMenu isDropDown={isDropDown}>
                  {years.map((year, index: number) => (
                    <DropDownMenuList
                      selected={selectedIndex === index}
                      key={year}
                      onClick={() => handleSelectedIndex(index)}
                    >
                      {year}
                    </DropDownMenuList>
                  ))}
                </DropDownMenu>
              </FlyoutMenu>
            </div>
          </ChartContent>
          <ChartFlowContent>
            <ChartBigAmount>
              <div>
                <ChartAmountContent>
                  <ChartBigPrice>0</ChartBigPrice>
                  <ChartBigPercent>0%</ChartBigPercent>
                </ChartAmountContent>

                <div>
                  <ChartInnerDiv>
                    Click on any month to view monthly growth
                  </ChartInnerDiv>
                </div>
              </div>
            </ChartBigAmount>
            <ChartFlowContainer>
              <ChartFlowWrapper>
                <ChartFlowDiv>
                  <ChartFlow>
                    <Circle></Circle>Inflow
                  </ChartFlow>
                </ChartFlowDiv>
                <ChartFlowDiv>
                  <ChartFlow>
                    <Circle01></Circle01>Outflow
                  </ChartFlow>
                </ChartFlowDiv>
              </ChartFlowWrapper>
            </ChartFlowContainer>
          </ChartFlowContent>
        </ThirdChart>
      </BigChartWrapper>
      <ChartData>
        <ResponsiveContainer width="100%" height={300} className="mobile">
          <AreaChart
            data={dataTrans}
            margin={{
              top: 10,
              right: 10,
              left: 0,
              bottom: 0,
            }}
          >
            <defs>
              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#09005B" />
                <stop offset="48.25%" stopColor="#F0EFFF" />
                <stop offset="103.37%" stopColor="#FFFFFF" />
              </linearGradient>
              <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#63D465" />
                <stop offset="48.25%" stopColor="#FAFAFF" />
                <stop offset="103.37%" stopColor="#FFFFFF" />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3" vertical={false} />
            <XAxis
              dataKey="name"
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#5E5E5E", fontSize: 12 }}
            />
            <YAxis
              domain={[0, Math.max(...dataTrans.map((month) => month.amt))]}
              tickLine={false}
              axisLine={false}
              tickFormatter={(value) => `$ ${value}`}
              tick={{ fill: "#5E5E5E", fontSize: 12 }}
            />
            <Tooltip />
            <Area
              type="monotone"
              dataKey="pv"
              stroke="#09005B"
              fill="url(#areaColor)"
              fillOpacity={0.3}
            />
            <Area
              type="monotone"
              dataKey="uv"
              stroke="#00C703"
              fill="url(#colorPv)"
              strokeWidth={2.1}
            />
          </AreaChart>
        </ResponsiveContainer>
      </ChartData>
    </BigChartContainer>
  );
};

export default Index;
